<script setup lang="ts">
interface Props {
  closeable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  closeable: false
})

const { closeable } = toRefs(props)

const { close } = assertInject(DialogInjection)
</script>

<template>
  <div aria-hidden="true" class="dialog-overlay fixed inset-0" @[closeable?`click`:null].self.stop.prevent="close" />
</template>